"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isQuantitative = void 0;
var isQuantitative = function (_a) {
    var sku = _a.sku, parentSku = _a.parentSku;
    return ((sku === "FLEXLOAD" && parentSku === "MANVAN") || parentSku === "SURCHARGES");
};
exports.isQuantitative = isQuantitative;
